<div class="row">
  <div class="col-md-12 col-sm-12">
    <div class="card">
      <div class="card-header text-center">
        <h5>LISTA DE PEDIDOS ANULADOS</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <input
              class="form-control"
              #searchTerm
              (keyup)="search(searchTerm.value)"
              placeholder="Buscar pedidos..."
            />
          </div>
        </div>
        <br />

        <div *ngIf="pedidos && !orderService.isLoading">
          <table class="table table-bordered table-hover table-sm table-md">
            <thead>
              <tr class="text-center">
                <th>#</th>
                <th>Cod.</th>
                <th>Estado</th>
                <th>F. Registro</th>
                <th>F. Entrega</th>
                <th>Cliente</th>
                <th>Vendedor</th>
                <th>Total</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody *ngFor="let order of pedidos.data; let i = index">
              <tr>
                <th scope="row" class="text-right">{{ i + 1 }}</th>
                <th>{{ order.orden_id }}</th>
                <td class="text-center">
                  <span class="badge badge-info">{{ order.estado }}</span>
                </td>
                <td class="text-center">
                  {{ order.fecha | date: 'dd/MM/yyyy' }}
                </td>
                <td class="text-center">
                  {{ order.fecha_entrega | date: 'dd/MM/yyyy' }}
                </td>
                <td>
                  {{ order.cliente.nombres }} {{ order.cliente.apellidos }}
                </td>
                <td>
                  {{ order.vendedor.nombres }} {{ order.vendedor.apellidos }}
                </td>
                <td>
                  {{ order.total }}
                </td>
                <td>
                  <h6 class="text-center">
                    <div *ngIf="order.estado != 'CONCLUIDO'">
                      <a
                        *hasPermission="['vendedor']"
                        class="btn btn-info text-white"
                        [routerLink]="['/dashboard/order-edit', order.orden_id]"
                      >
                        Detalle
                      </a>

                      <button
                        *ngIf="order.estado != 'ANULADO'"
                        type="button"
                        (click)="eliminar(order.orden_id)"
                        class="btn btn-danger"
                      >
                        <i class="fa fa-trash" style="font-size: 25px"></i>
                      </button>
                      <span *ngIf="order.estado == 'PEDIDO'">
                        <a
                          *hasPermission="['administrador', 'almacen']"
                          class="btn btn-info text-white"
                          [routerLink]="[
                            '/dashboard/order-edit',
                            order.orden_id
                          ]"
                        >
                          Despachar
                        </a>
                      </span>
                      <span *ngIf="order.estado == 'DESPACHADO'">
                        <a
                          *hasPermission="['administrador', 'almacen']"
                          class="btn btn-warning text-white"
                          [routerLink]="[
                            '/dashboard/order-edit',
                            order.orden_id
                          ]"
                        >
                          Vender
                        </a>
                      </span>
                    </div>
                    <button
                      *ngIf="order.estado == 'PEDIDO'"
                      (click)="showPDF(order.orden_id)"
                      class="btn btn-primary"
                    >
                      <i class="fa fa-print"></i>
                    </button>
                    <button
                      *ngIf="
                        order.estado == 'DESPACHADO' ||
                        order.estado == 'CONCLUIDO'
                      "
                      (click)="showPDF(order.orden_id)"
                      class="btn btn-primary"
                    >
                      <i class="fa fa-print"></i>
                    </button>
                  </h6>
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            Mostrando pedidos {{ pedidos.from }} a {{ pedidos.to }} de
            {{ pedidos.total }}
          </p>
          <p>Página {{ pedidos.current_page }} de {{ pedidos.last_page }}</p>
          <button (click)="prevPage()" [disabled]="!pedidos.prev_page_url">
            Anterior
          </button>
          <button (click)="nextPage()" [disabled]="!pedidos.next_page_url">
            Siguiente
          </button>
        </div>
        <p *ngIf="orderService.isLoading">Cargando...</p>
      </div>
    </div>
  </div>
</div>
